import theme from 'src/theme';
import styled, { css } from 'styled-components';

export const ViolationListMainWrapper = styled.ul`
    height: 100%;
`;

export const ViolationListFilterBarStyle = styled.div`
    display: flex;
    justify-content: space-between;
    overflow: hidden;

    padding: 5px 10px;
    background: ${({ theme }) => theme.colors.background.white};
    font-weight: 600;

    .left-wrapper {
        gap: 15px;
        display: flex;
    }

    .right-wrapper {
        gap: 5px;
        display: flex;
    }
`;

export const ViolationListStyle = styled.div`
    background: ${({ theme }) => theme.colors.background.white};
    height: 100%;
    overflow-y: auto;
    position: relative;
    scrollbar-gutter: stable;
    padding-top: 30px;
    outline: none;
    .operation-list-menu {
        background: transparent;
        display: flex;
    }
    .transit-op {
        padding: 5px;
        margin: 5px;
        font-style: italic;
        font-weight: 600;
        font-size: 0.8rem;
    }
`;

const ViolationListItemGeneralStyle = css`
    justify-content: space-between;
    display: flex;
    cursor: pointer;
    position: relative;
    border: 1px solid transparent;
    &:hover {
        background: ${({ theme }) => theme.colors.background.lightGrey};
    }

    &.selected-violation {
        background: ${theme.legacyColors.selectedBackground};
        border: 1px solid ${({ theme }) => theme.colors.border.portCall};
    }

    .col {
        border: 1px solid ${({ theme }) => theme.colors.border.ccc};
        padding: 4px 0px 0px 4px;
        flex: 0 0 14%;
        font-size: 0.83rem;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 0.8rem;
        margin: 0 1px;

        &.col-menu {
            flex: 0 0 55px;
            gap: 2px;
            overflow: visible;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
        &.col-type {
            flex: 0 0 90px;
        }
        &.col-cargo-nr {
            flex: 0 0 105px;
            font-size: 0.7rem;
        }
        &.col-description {
            flex: 1 0 33%;
        }
        &.col-voyage {
            flex: 0 0 90px;
        }
        &.col-tank {
            flex: 0 0 90px;
        }
        &.col-left {
            text-align: left;
        }
        &.col-right {
            text-align: right;
        }
        &.col-accepted-by {
            flex: 0 0 160px;
        }
        &.col-date-time {
            flex: 0 0 120px;
        }
    }

    .sort-icon {
        font-size: 0.65rem;
        margin: 0 2px;
    }
`;

export const ViolationListItemStyle = styled.li`
    ${ViolationListItemGeneralStyle}
`;

export const ViolationListHeaderStyle = styled.div`
    ${ViolationListItemGeneralStyle}
    font-weight: 500;
    font-size: 0.8rem;
    position: sticky;
    top: -30px;
    width: 100%;
    z-index: 1;
    margin-top: -30px;
    background: ${({ theme }) => theme.colors.background.white};

    .col {
        border: 1px solid ${({ theme }) => theme.colors.border.ccc};
        text-align: center;
        background: ${({ theme }) => theme.colors.background.lightGrey};
        font-size: 0.75rem;
        &.col-cargo-nr,
        &.col-trade-name,
        &.col-stowed,
        &.col-ports {
            font-size: 0.75rem;
            text-align: center;
        }
    }
`;

export const ViolationStatusIconsWrapper = styled.div`
    display: flex;
    gap: 5px;
    align-items: center;
    & > * {
        flex: 1 1 25%;
    }
`;

export const ViolationMenuWrapper = styled.div`
    width: 100%;
    height: 5px;
    position: relative;
`;
